/**
 * FAQ Store Module
 *
 * Manages FAQ training data, ML model operations, and topic-based organization.
 * Provides functionality to:
 * - Add, test, and train FAQ intents
 * - Manage training and conversational datasets
 * - Handle topic-based grouping and training
 * - Test models with test data
 * - Search and label unlabeled messages
 * - Track training and publishing progress
 *
 * @module store/modules/faq
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { FaqState } from "./types";
import { RootState } from "@/store/types";

const Faq: Module<FaqState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default Faq;
